<template>
	<div class="footer">
	  <img src="/src/assets/images/sj_38.png" class="footer-top" />
	  <div class="footer-box">
		<div class="footer-box-links">
			<a v-for="(item,index) in Classdata" :key="item.id" :href="item.linkurl">{{item.classname}}</a>
		</div>
		<div class="footer-box-dottle-line"></div>
		<div class="footer-bott">
		<div class="footer-box-lef">
			<img :src="Idx_bott_logo" />
			<div v-html="Copyright" class="footer-box-lef-bott"></div>
		</div>
		<div class="footer-box-rig">
			<img :src="Idx_bott_wxqrcode" />
			<p>实时了解最新资讯</p>
			<p>关注鸿龙寨官方微信</p>
		</div>
		</div>
	  </div>
	</div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
	Recordno:String,
	Copyright:String,
	Classdata:Array,
	Idx_bott_logo:String,
	Idx_bott_wxqrcode:String,
  },
  data () {
      return {
      }
   }
}
</script>
<style>
	@import url("/src/assets/style/footer.css");
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue